import styled from "styled-components";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import { H3, P } from "@streeteasy/design-system/typography";

export const CheckMark = styled(FontAwesomeIcon).attrs({
  color: "primary",
  fontSize: "32px",
  iconClass: "check"
})``;

export const CheckMarkContainer = styled.div`
  margin-bottom: 20px;
  text-align: center;
`;

export const SuccessMessageContainer = styled.div``;

export const SuccessText = styled(P)`
  text-align: center;
`;

export const SuccessTextContainer = styled.div`
  padding-top: 8px;
`;

export const SuccessTitle = styled(H3)`
  text-align: center;
`;

export const CTAContainer = styled.div`
  margin-top: 32px;
`;
